import { api, setTokens, setStoredUser, clearTokens, getLegacyRefreshToken } from './client'

export async function login(email, password) {
  const { data } = await api.post('/auth/login', { email, password })
  // Akun ber-2FA belum mendapat sesi: kata sandi saja tidak cukup. Jawabannya
  // hanya membawa `mfaToken`, yang ditukar di verifyLogin2fa().
  if (data.mfaRequired) return data
  setTokens({ accessToken: data.accessToken })
  setStoredUser(data.user)
  return data
}

// Langkah kedua login: token sementara + kode dari aplikasi autentikator
// (atau kode pemulihan).
export async function verifyLogin2fa(mfaToken, code) {
  const { data } = await api.post('/auth/login/2fa', { mfaToken, code })
  setTokens({ accessToken: data.accessToken })
  setStoredUser(data.user)
  return data
}

export const get2faStatus = () => api.get('/auth/2fa/status').then((r) => r.data)
export const setup2fa = () => api.post('/auth/2fa/setup').then((r) => r.data)
export async function enable2fa(code) {
  const { data } = await api.post('/auth/2fa/enable', { code })
  // Token baru tanpa pembatasan pendaftaran — pengguna langsung bisa bekerja.
  setTokens({ accessToken: data.accessToken })
  return data
}
export const regenerateRecoveryCodes = (password, code) =>
  api.post('/auth/2fa/recovery-codes', { password, code }).then((r) => r.data)
export const disable2fa = (password, code) =>
  api.post('/auth/2fa/disable', { password, code }).then((r) => r.data)

export async function loginWithQR(qrToken, { deviceId, deviceLabel } = {}) {
  const body = { qrToken }
  if (deviceId) body.deviceId = deviceId
  if (deviceLabel) body.deviceLabel = deviceLabel
  const { data } = await api.post('/auth/qr-login', body)
  setTokens({ accessToken: data.accessToken })
  setStoredUser(data.user)
  return data
}

/**
 * Gabung kelas: peserta yang belum pernah ada di sistem mendaftarkan dirinya
 * sendiri dengan kode kelas yang ditampilkan pelatih. Kata sandi opsional —
 * kalau diisi, dipakai HANYA saat akun ini benar-benar baru dibuat, supaya
 * peserta bisa masuk lewat tab Email lain kali. Kalau email diisi itu menjadi
 * identitas akunnya (bisa dipakai "Lupa password" & notifikasi nanti); kalau
 * kosong, nama+perusahaan yang jadi identitasnya seperti sebelumnya.
 */
export async function joinWithCode({ code, fullName, company, placeOfBirth, dateOfBirth, email, phone, password }) {
  const { data } = await api.post('/auth/join', { code, fullName, company, placeOfBirth, dateOfBirth, email, phone, password })
  setTokens({ accessToken: data.accessToken })
  setStoredUser(data.user)
  return data
}

/**
 * Catat program yang sedang dibuka, supaya sesi berikutnya mendarat di tempat
 * yang sama. Disimpan di server, bukan hanya di browser: peserta yang keluar
 * lalu masuk lagi — atau berganti perangkat — tetap tidak perlu memilih ulang.
 */
export async function setCurrentProgram(programId) {
  const { data } = await api.patch('/auth/current-program', { programId })
  return data
}

/**
 * Tandai layar sambutan staf sudah dilihat — pada AKUN, bukan peramban.
 *
 * Penanda lama disimpan di localStorage, sehingga melekat pada perangkat: di
 * komputer yang dipakai bergantian, admin baru tidak pernah melihat
 * perkenalannya sama sekali.
 */
export async function markStaffWelcomeSeen() {
  const { data } = await api.patch('/auth/staff-welcome-seen')
  return data
}

export async function listDevices() {
  const { data } = await api.get('/auth/devices')
  return data
}

export async function confirmDevice(deviceId) {
  const { data } = await api.post(`/auth/devices/${encodeURIComponent(deviceId)}/confirm`)
  return data
}

export async function revokeDevice(deviceId) {
  const { data } = await api.delete(`/auth/devices/${encodeURIComponent(deviceId)}`)
  return data
}

export async function logout() {
  // Cookie HttpOnly ikut otomatis; token lama (kalau ada) dikirim agar ikut dicabut.
  const refreshToken = getLegacyRefreshToken()
  try {
    await api.post('/auth/logout', refreshToken ? { refreshToken } : {})
  } catch (e) {
    // ignore
  }
  clearTokens()
}

export async function getCurrentUser() {
  const { data } = await api.get('/users/me')
  return data
}

export async function requestPasswordReset(email) {
  const { data } = await api.post('/auth/forgot-password', { email })
  return data
}

export async function resetPassword({ token, password }) {
  const { data } = await api.post('/auth/reset-password', { token, password })
  return data
}

// Ganti email, dua tahap. Tahap 1 minta kata sandi (dan kode 2FA bila akunnya
// memakainya) lalu mengirim tautan ke alamat BARU; tahap 2 dijalankan ketika
// tautan itu dibuka (lihat AppContext). Tidak ada token yang disentuh di sini.
export const requestEmailChange = ({ newEmail, password, code }) =>
  api.post('/auth/change-email/request', { newEmail, password, ...(code ? { code } : {}) }).then((r) => r.data)
export const confirmEmailChange = (token) =>
  api.post('/auth/change-email/confirm', { token }).then((r) => r.data)
